import React from "react";
import { dateFormatWithTime } from "../../utils/date";
import Auth from "../../utils/auth";
import * as queryService from "../../services/query/query-service";
import * as Loader from "../../common/common";
import { withRouter } from "../../common/hocs";
class QueryDetails extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      id: "",
      data: "",
      reply: "",
      validationErrors: {
        reply: "",
      },
    };
    this.saveAnswer = this.saveAnswer.bind(this);
    this.getQueryData = this.getQueryData.bind(this);
  }

  componentDidMount() {
    this.getQueryData();
  }

  async getQueryData() {
    Loader.showLoader();
    const { id } = this.props.params;
    let { response, err } = await queryService.getQueryDetails(id);
    Loader.hideLoader();
    if (err) {
    } else if (response && response.data.err) {
    } else {
      let data = response.data.data;
      this.setState({
        data: data,
        loading: false,
      });
    }
  }
  onChange(e) {
    const value = e.target.value;
    this.setState({
      reply: value.toUpperCase(),
    });
  }
  onClickReplyBtn(e) {
    if (this.state.reply) {
      this.saveAnswer();
    }
  }
  async saveAnswer() {
    let data = {
      reply: this.state.reply,
      queryId: this.props.params.id,
    };
    Loader.showLoader();
    let { response, err } = await queryService.saveAnswer(data);
    Loader.showLoader();
    if (err) {
    } else if (response && response.data.err) {
    } else {
      if (response.data.success) {
        this.setState({
          ...this.state,
          reply: "",
        });
        this.getQueryData();
      }
    }
  }
  render() {
    return (
      <div className="container ">
        <div className="row queryDetails ">
          {this.state.data && (
            <div
              className="col-sm-12 p-4 mt-2 ml-1 "
              style={{ background: "#fff" }}
            >
              <h3>
                {" "}
                <strong>Subject : </strong> {this.state.data[0].subject}{" "}
              </h3>
              <div>
                <strong>Message : </strong> {this.state.data[0].message}
              </div>
              <div>
                <strong>Created At : </strong>
                {dateFormatWithTime(this.state.data[0].createdAt)}
              </div>
              <div className="row mt-3">
                <div className="col-sm-10">
                  <div className="form-group">
                    <textarea
                      rows="5"
                      type="text"
                      placeholder="Type your reply here.."
                      className="form-control"
                      name="reply"
                      onChange={this.onChange.bind(this)}
                      value={this.state.reply}
                    />
                    <br />
                    <input
                      type="button"
                      className="btn btn-primary"
                      value="Reply"
                      onClick={this.onClickReplyBtn.bind(this)}
                    />
                  </div>
                </div>
              </div>
              {this.state.data[0].querydetails.map((x) => {
                let d = dateFormatWithTime(x.createdAt);

                return (
                  <div className="row" key={x.createdAt}>
                    <div className="col-sm-10">
                      <ul className="comments-list">
                        <li className="comment">
                          <a className="pull-left px-2 py-1 mt-1 text-white border rounded bg-primary">
                            <i className="fa fa-user"></i>
                          </a>
                          <div className="comment-body">
                            <div className="comment-heading">
                              <h4 className="user">
                                {x.userdetail.companyName}
                              </h4>
                              {/* <h5 className="time">5 minutes ago</h5> */}
                              <h5 className="time">at {d}</h5>
                            </div>
                            <p>{x.reply}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

// HOC to inject router params
export default withRouter(QueryDetails);